import React from 'react'
import styles from '../home.module.css'
import { Button } from 'semantic-ui-react';
import { Link } from 'gatsby';
import LazyLoad from 'react-lazyload'
import LazyPlaceHolder from '../../Comon/LazyPlaceHolder'

const Presentation = ({data}) => {
    const { title, present, image } = data
    return (
        <section id={styles.presentation} className={`container ${styles.presentation_section}`}>
            <div className="ui stackable two column grid">
                <div className="column">
                    <LazyLoad
                        height={300}
                        placeholder={<LazyPlaceHolder height={300} />}>
                        <div className={styles.image_container}>
                            <img src={image} alt="presentation" />
                        </div>
                    </LazyLoad>
                </div>
                <div className="column">
                    <h1> {title} </h1>
                    <p>{present}</p>
                    <Link to="#"><Button color="red">En savoir plus</Button></Link>
                </div>
            </div>
        </section>
    )
}
export default Presentation